import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchArticle = articleId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.fetchSingleArticle(api.getSingleArticle(token, articleId))
    );
  };
};

export const fetchLatestArticles = ({
  limit,
  order,
  isPublic = true,
  conditions = []
}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_LATEST_ARTICLES", dispatch);

    const { lng, publicPortal } = getState().params;
    const { auth } = getState();
    const { token, loggedAs } = auth;
    const community = isPublic
      ? { ...publicPortal.community }
      : { ...auth.navCommunity };

    return dispatch(
      actions.fetchArticles(
        api
          .getArticles({
            token,
            limit,
            language: lng,
            isPublic,
            communityId: community.id,
            conditions,
            sourceToken,
            loggedAs
          })
          .then(resp => {
            return { ...resp, data: { ...resp.data, order } };
          })
      )
    );
  };
};

export const fetchWorkflow = ({ limit }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_WORKFLOW", dispatch);

    const { lng } = getState().params;
    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchWorkflow(
        api.getWorkflow({
          token,
          limit,
          language: lng,
          communityId: navCommunity.id,
          sourceToken
        })
      )
    );
  };
};

/*
  function extractCommunitiesId(communities) {
    let ids = [];
    for (let community of communities) {
      ids.push(community.id);
    }
    return ids;
  }
  export const fetchLatestResources = ({ type, limit, offset, search }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_LATEST_ARTICLES", dispatch);

    const { lng } = getState().params;
    const { auth } = getState();
    const { token, user, navCommunity } = auth;

    let communitiesId = [];
    if (navCommunity) {
      communitiesId.push(navCommunity.id);
    } else if (user && user.communities && user.communities.length > 0) {
      communitiesId = extractCommunitiesId(user.communities);
    }

    switch (type) {
      case "IMAGE":
      case "PDF":
      case "PPT":
      case "VIDEO":
        return dispatch(
          actions.fetchArticles(
            api.getMedias({
              token,
              limit,
              offset,
              lng,
              type,
              search,
              communitiesId,
              sourceToken
            })
          )
        );
      case "TOPIC":
        return dispatch(
          actions.fetchArticles(
            api.getLatestTopics({
              token,
              limit,
              search,
              offset,
              language: lng,
              community: navCommunity.id,
              sourceToken
            })
          )
        );
      case "ARTICLE":
        return dispatch(
          actions.fetchArticles(
            api.getArticles({
              token,
              limit,
              search,
              offset,
              language: lng,
              communityId: communitiesId[0],
              sourceToken
            })
          )
        );
      default:
        return dispatch(
          actions.fetchArticles(
            api.getLatestArticles({
              token,
              limit,
              search,
              offset,
              language: lng,
              communitiesId,
              sourceToken
            })
          )
        );
    }
  };
};*/



// WEBPACK FOOTER //
// ./src/actions/thunks/article.js